<template>
  <b-form @submit.prevent="submit">
    <b-tabs small card>
      <b-tab title="General">
        <b-form-group label="Nombre">
          <b-form-input v-model="plantillaContrato.nombre" required type="text" placeholder="Nombre de la plantilla" />
        </b-form-group>

        <b-form-group label="Unidades de negocio">
          <combo-multiple
            :value="unidadesNegocioIdCombo"
            :options="opcionesUnidadesNegocio"
            url="unidadNegocio/autocompletar"
            @input="selectUnidadesNegocio"
          />
        </b-form-group>

        <b-form-group label="Estado">
          <b-form-checkbox switch size="lg" v-model="plantillaContrato.estado"> Activa </b-form-checkbox>
        </b-form-group>
      </b-tab>
      <b-tab title="Contrato">
        <b-form-group label="Formato del contrato a generar">
          <wysiwyg
            id="editorTextoContrato"
            v-model="plantillaContrato.textoContrato"
            placeholder="Escriba aquí"
            :options="opcionesEditor"
          />
        </b-form-group>
      </b-tab>
      <b-tab title="Borrador">
        <b-form-group label="Formato del contrato en borrador">
          <wysiwyg
            id="editorTextoBorrador"
            v-model="plantillaContrato.textoBorrador"
            placeholder="Escriba aquí"
            :options="opcionesEditor"
          />
        </b-form-group>
      </b-tab>
    </b-tabs>

    <botonera-edicion url-cancelar="/plantillasContrato" />
  </b-form>
</template>
<script>
import * as unidadesNegocioApi from "@/services/unidadesNegocio.js";
import EditorShortcodes from "@/components/editor/ModuloShortcodesContrato.vue";
export default {
  props: {
    plantillaContrato: Object,
    unidadesNegocioId: Array,
    opcionesUnidadesNegocio: Array,
  },
  data() {
    return {
      listaUnidadesNegocio: [],
      unidadesNegocioIdCombo: this.unidadesNegocioId ? this.unidadesNegocioId : [],
      unidadesNegocioSeleccionadas: [],
      opcionesEditor: {
        customModules: [EditorShortcodes],
      },
    };
  },
  computed: {},
  watch: {
    "$route.params": {
      handler: function () {
        this.listarUnidadesNegocio();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    listarUnidadesNegocio() {
      return unidadesNegocioApi.listar(this.$route.query).then((resultado) => {
        this.listaUnidadesNegocio = resultado.unidadesNegocio;
      });
    },
    selectUnidadesNegocio(unidadesNegocioCombo) {
      this.unidadesNegocioSeleccionadas = [];
      var un = {};
      for (un in unidadesNegocioCombo) {
        this.unidadesNegocioSeleccionadas.push({
          plantillaContratoId: this.plantillaContrato.id,
          unidadNegocioId: unidadesNegocioCombo[un],
        });
      }
    },
    submit() {
      this.$emit("submit", this.unidadesNegocioSeleccionadas);
    },
  },
};
</script>
